var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    fill: "none",
    viewBox: "0 0 16 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#667085",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 7.167 9.333 4.5M1.667 14.833l2.256-.25c.276-.03.413-.046.542-.088a1.33 1.33 0 0 0 .324-.155c.113-.075.21-.173.407-.37L14 5.168A1.886 1.886 0 1 0 11.333 2.5L2.53 11.304c-.196.196-.294.294-.368.407-.067.1-.119.21-.156.324-.042.129-.057.267-.088.542l-.25 2.256Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon2);
export default __webpack_public_path__ + "static/media/edit-icon2.9468f3a0ff235a3b6e318efca7a574c4.svg";
export { ForwardRef as ReactComponent };